//@flow
import io from 'socket.io-client'
import qs from 'qs'
import { displayErrorScreen } from './utils'
import store from './state/store'
import { restoreLearner } from './state/learner/actions'
import { updateConnectionStatus } from './state/quiz/actions'

const socket = io('/quiz')

export default socket

// link socket connect status to redux state
socket.on('connect', () => {
  processReconnectionCallbacks()
  store.dispatch(updateConnectionStatus(true))
})
socket.on('disconnect', () => {
  store.dispatch(updateConnectionStatus(false))
})

// re-register learner on reconnection event
socket.on('reconnect', () => {
  socket.emit('status', status => {
    const { invite } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    if (invite && (!status || !status.registered)) {
      store.dispatch(restoreLearner(invite))
    }
  })
})

// allow server access to local state
socket.on('quiz:echoState', cb => {
  const { learner } = store.getState()
  cb(learner.get('currentQuestionId'))
})

// handle errors
socket.on('error', (error: string): void => {
  if (error === 'Invalid Client') {
    return displayErrorScreen(
      'The page you are looking for does not exist.\nPlease contact your learning administrator.',
      false,
    )
  }
  if (error === 'Inactive Client') {
    return displayErrorScreen(
      'The system you are looking for has been disabled.\nPlease contact your learning administrator.',
      false,
    )
  }

  throw error
})

const reconnectionCallbacks = []

/**
 * Queues callback to run when socket is connected.
 * @memberof socket
 */
export function whenConnected(fn: Function) {
  if (socket.connected) {
    setImmediate(fn, true)
    return
  }
  reconnectionCallbacks.push(fn)
}

/**
 * Runs reconnection callbacks.
 * @memberof socket
 */
function processReconnectionCallbacks() {
  for (const fn of reconnectionCallbacks) {
    fn()
  }
}



// WEBPACK FOOTER //
// ./src/socket.js